import { AlertStatusBadge } from '@/alerts/view/components/alert-status-badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { Alert } from '@/entities/alert';

import { lookerStyle } from './looker-style';

export type TableSuggestedActionsProps = {
  alert: Alert;
};

export function TableSuggestedActions({ alert }: TableSuggestedActionsProps) {
  const style = lookerStyle();
  return (
    <Table grid dense className={style.table()}>
      <TableHead className={style.tableHead()}>
        <TableRow>
          <TableHeader className={style.tableHeader()}>&nbsp;</TableHeader>
          <TableHeader className={style.tableHeader()}>ID</TableHeader>
          <TableHeader className={style.tableHeader()}>Status</TableHeader>
          <TableHeader className={style.tableHeader()}>
            Suggested Action
          </TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow key={alert.fullFrontendId} className={style.tableRow()}>
          <TableCell className={style.tableCell()}>1</TableCell>
          <TableCell className={style.tableCell()}>
            {alert.fullFrontendId}
          </TableCell>
          <TableCell className={style.tableCell()}>
            <AlertStatusBadge status={alert.status} />
          </TableCell>
          <TableCell className={style.tableCell()}>
            {alert.suggestedAction}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
